export default "__VITE_ASSET__BakCheQH__"